import React from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import { useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { trackCTA } from '../utils/analytics';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../i18n/content';

const Footer = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const { language } = useLanguage();
  const t = content[language].footer;

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.6 }
  };

  return (
    <footer className="relative py-24 px-4 overflow-hidden premium-bg-2 border-t border-white/5">
      <div className="container mx-auto max-w-6xl relative z-10">
        <motion.div 
          className="text-center mb-16"
          {...fadeIn}
        >
          <Link to="/" className="inline-block">
            <img 
              src="/assets/logo/golden_eye_logo.png" 
              alt="DigitalFlow" 
              className="h-16 w-auto mx-auto mb-6 drop-shadow-2xl object-contain"
            />
          </Link>
          <p className="text-white/50 text-lg font-light max-w-md mx-auto">
            {t.tagline}
          </p>
        </motion.div>

        <motion.div 
          className="flex flex-col md:flex-row justify-center items-center gap-10 mb-16"
          {...fadeIn}
        >
          {isHomePage ? (
            <>
              <ScrollLink 
                to="hero" 
                smooth={true} 
                duration={500}
                className="text-white/70 hover:text-secondary transition-colors duration-300 cursor-pointer text-lg"
              >
                {t.home}
              </ScrollLink>
              <ScrollLink
                to="trust"
                smooth={true}
                duration={500}
                className="text-white/70 hover:text-secondary transition-colors duration-300 cursor-pointer text-lg"
              >
                {t.work}
              </ScrollLink>
              {/* <Link 
                to="/catalogo"
                className="text-white/70 hover:text-secondary transition-colors duration-300 text-lg"
              >
                Catálogo
              </Link> */}
            </>
          ) : (
            <>
              <Link 
                to="/"
                className="text-white/70 hover:text-secondary transition-colors duration-300 text-lg"
              >
                {t.home}
              </Link>
              {/* <Link
                to="/catalogo"
                className="text-white/70 hover:text-secondary transition-colors duration-300 text-lg"
              >
                Catálogo
              </Link> */}
            </>
          )}
        </motion.div>

        <motion.div
          className="text-center text-white/40 text-sm md:text-base space-y-3 font-light"
          {...fadeIn}
        >
          <div className="flex justify-center items-center gap-4 mb-6">
            <div className="h-px w-16 bg-white/10"></div>
            <p>{t.location}</p>
            <div className="h-px w-16 bg-white/10"></div>
          </div>
          <p>
            <a
              href="mailto:info@digitalflowsv.com"
              onClick={() => trackCTA('footer', 'Email Click')}
              className="hover:text-secondary transition-colors"
            >
              info@digitalflowsv.com
            </a>
          </p>
          <p className="pt-4 text-white/30">
            © {new Date().getFullYear()} DigitalFlow. {t.rights}
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;

